import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';

export const productReleaseResources = {
  getProductReleases: createResourceBuilder(
    '/drmrust/v2.1/admin/releases/product/:product_id',
    EResourceMethod.Get,
    (product_id: string) => ({ product_id })
  ),
  getProductInstallers: createResourceBuilder(
    '/drmrust/v2.1/admin/releases/product/:product_id/new',
    EResourceMethod.Get,
    (product_id: string) => ({ product_id })
  ),
  createProductReleaseVersion: createResourceBuilder(
    '/drmrust/v2.1/admin/releases/product/:product_id/version/:version',
    EResourceMethod.Post,
    (product_id: string, version: string) => ({ product_id, version })
  ),
  updateProductReleaseVersion: createResourceBuilder(
    '/drmrust/v2.1/admin/releases/product/:product_id/version/:version',
    EResourceMethod.Put,
    (product_id: string, version: string) => ({ product_id, version })
  ),
  deleteProductReleaseVersion: createResourceBuilder(
    '/drmrust/v2.1/admin/releases/product/:product_id/version/:version',
    EResourceMethod.Delete,
    (product_id: string, version: string) => ({ product_id, version })
  ),
};
